import { StaticImage } from "gatsby-plugin-image";
import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";

export default function AutoOpenModal() {
  const [show, setShow] = useState(false);

  // ให้เปิดหลังจาก component mount (กัน SSR ของ Gatsby)
  useEffect(() => {
    setShow(true);
  }, []);

  return (
    <>
      {/* ปุ่มไว้ทดสอบเปิดซ้ำ (ไม่จำเป็น) */}
      {/* <Button className="d-none" onClick={() => setShow(true)}>Open</Button> */}

      <Modal
        show={show}
        onHide={() => setShow(false)}
        size="md"
        centered
        // กรณีมี element อื่น z-index สูง ใช้ container ให้ portal ไปที่ body
        container={typeof document !== "undefined" ? document.body : undefined}
        // ตัวเลือกเพิ่มเติม
        backdrop="static"   // กันคลิกนอกแล้วปิด (ถ้าไม่ต้องการลบได้)
        keyboard={false}    // กด ESC ไม่ปิด (ถ้าไม่ต้องการลบได้)
      >
        <Modal.Body>
            <StaticImage src="../images/queen-thailand.jpg" alt="Queen Thailand" />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            ปิด
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}